import type { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import type { TranslatableEntity } from './types';

type TranslatableProps = Pick<TranslatableEntity, 'translationKey'>;

export const Translatable: FunctionComponent<TranslatableProps> = ({
  translationKey,
}) => {
  return (
    <span>
      <FormattedMessage
        id={`actions.${translationKey}`}
        defaultMessage="unknown"
        description="Action text"
      />
    </span>
  );
};
